import { EnrolmentReviewStartedEventPayload } from './enrolment-review-started-event-payload';
import { Event } from './event';

export class ClientEnrolmentReviewStartedEvent extends Event<EnrolmentReviewStartedEventPayload> {}
